// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ChartOutlinedSvg from "@fishx/icons-svg/es/asn/ChartOutlined";
import FishxIcon from '../components/FishxIcon';

var ChartOutlined = function ChartOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ChartOutlinedSvg
  }));
};

ChartOutlined.displayName = 'ChartOutlined';
export default React.forwardRef(ChartOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ChartOutlined.js
// module id = 2190
// module chunks = 0